import keymirror from "../utils/keymirror";

export const EditProfileConstants = keymirror(
    {
        OPEN_PROFILE: null,
        EDIT_PROFILE: null,
        SAVE_PROFILE: null,
        SAVE_PROFILE_SUCCESS: null,
        SAVE_PROFILE_FAILURE: null,
        CLOSE_PROFILE: null
    },
    "editProfile"
);



// WEBPACK FOOTER //
// ./src/constants/editProfile.constants.js